module.exports = __webpack_public_path__ + "static/img/Chad_Wingard_mobile.56c5e8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Chad_Wingard_mobile.jpg
// module id = kTwT
// module chunks = 0